import React from 'react'
import { GridHeader, GridRow } from 'src/components/Reusable/Grid'
import { getControlsListItemConfig } from '../../IndexItem/ControlsListItem.helpers'
import { ControlListItemConfig } from '../../IndexItem/ControlListItem.constants'
import { ControlsGridHeader } from './ControlsIndexGrid.styles'
import {
  ControlIndexGridChecksHeaders,
  ControlsIndexGridAssigneeHeader,
  ControlsIndexGridAutomatedEvidenceHeader,
  ControlsIndexGridDepartmentHeader,
  ControlsIndexGridFrameworksHeader,
  ControlsIndexGridIdHeader,
  ControlsIndexGridManualEvidenceHeader,
  ControlsIndexGridNameHeader,
  ControlsIndexGridStatusHeader,
} from './ControlsIndexGrid.components'

export const ControlsIndexGridHeader = ({
  config,
  showContentMatchColumn,
}: {
  config?: ControlListItemConfig
  showContentMatchColumn?: boolean
}): JSX.Element => {
  const {
    showDepartmentColumn,
    showModelIdColumn,
    showControlNameColumn,
    showFrameworkColumn,
    showCheckColumns,
    showAutomatedEvidenceColumns,
    showManualEvidenceColumns,
    showStatusColumn,
    showAssigneeColumn,
    showMenuColumn,
  } = getControlsListItemConfig(config)

  return (
    <GridRow>
      {showContentMatchColumn && <GridHeader />}
      {showDepartmentColumn && <ControlsIndexGridDepartmentHeader />}
      {showModelIdColumn && <ControlsIndexGridIdHeader />}
      {showControlNameColumn && <ControlsIndexGridNameHeader />}
      {showFrameworkColumn && <ControlsIndexGridFrameworksHeader />}
      {showCheckColumns && <ControlIndexGridChecksHeaders />}
      {showAutomatedEvidenceColumns && (
        <ControlsIndexGridAutomatedEvidenceHeader />
      )}
      {showManualEvidenceColumns && <ControlsIndexGridManualEvidenceHeader />}
      {showStatusColumn && <ControlsIndexGridStatusHeader />}
      {showAssigneeColumn && <ControlsIndexGridAssigneeHeader />}
      {showMenuColumn && <ControlsGridHeader />}
    </GridRow>
  )
}
